module.exports = __webpack_public_path__ + "a99f90fcac30bdc0424be1e9d6e6bf4d.png";